import modalTemplate from './modal.tpl.html';

export class Modal {
  close() {
    if (this.onClose) {
      this.onClose({});
    }
  }
}

export const tctModal = {
  template: modalTemplate,
  controller: Modal,
  restrict: 'E',
  transclude: {
    header: 'tctModalHeader',
    body: 'tctModalBody',
    footer: '?tctModalFooter',
  },
  bindings: {
    onClose: '&?',
  },
};
